import { render, staticRenderFns } from "./ClientBlockAlert.vue?vue&type=template&id=17a4294d"
import script from "./ClientBlockAlert.vue?vue&type=script&lang=js"
export * from "./ClientBlockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports